import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Icon } from "rsuite";
import ImagesContainer from "../Components/Images/ImagesContainer";
import UploadModal from "../Components/PreviewModal";
import { AlbumsContext } from "../context/albums.context";
import { useDate, useImageUploads, useSearchBar } from "../custom-hooks";
import { HomeWrapper } from "./Home.styled";
import { transformToArrayWithId } from "../misc/helper";
import MainPageLayout from "../Components/MainPageLayout";

const FileInputTypes = ".png , .jpg , .jpeg";

function AlbumDisc() {
  const { albumId } = useParams();

  const {
    img,
    preview,
    description,
    percentage,
    setPercentage,
    selectedImage,
    setSelectedImage,
    isOpen,
    close,
    onFileInputChange,
    onDescriptionChange,
    setDescription,
    open,
  } = useImageUploads();

  const { albums, isLoading } = useContext(AlbumsContext);

  const [images, setImages] = useState();
  const [currAlbum, setCurrAlbum] = useState();

  const { search, imgs, setimgs, handleSearchChange } = useSearchBar({
    images,
    isLoading,
  });

  const { fromDateValue, toDateValue, handleDateChange } = useDate({
    images,
    setimgs,
  });

  useEffect(() => {
    if (albums) {
      setCurrAlbum(() => {
        return albums.filter((item) => item.id === albumId);
      });
    }
  }, [albums, albumId]);

  useEffect(() => {
    if (currAlbum) {
      setImages(() => {
        return transformToArrayWithId(currAlbum[0].images);
      });
    }
  }, [currAlbum]);

  return (
    <>
      <MainPageLayout>
        <HomeWrapper>
          <h6 className="AlbumName">{currAlbum ? currAlbum[0].name : ""}</h6>

          <label htmlFor="FileUpload">
            <Icon icon="plus-circle" size="3x" strokeColor="red" />
            <input
              id="FileUpload"
              type="file"
              accept={FileInputTypes}
              onChange={onFileInputChange}
            />
          </label>
          <br />
          <div className="searchContainer">
            <input
              type="text"
              placeholder="search images here"
              id="searchBar"
              onChange={handleSearchChange}
              value={search}
            />
            <Icon icon="search" size="2x" />
          </div>
          <div className="dateFilterContainer">
            <label htmlFor="">
              from
              <input
                type="date"
                name="fromDate"
                id="fromDate"
                value={new Date(fromDateValue).toLocaleDateString("en-ca")}
                onChange={handleDateChange}
                max={new Date(toDateValue).toLocaleDateString("en-ca")}
              />
              <span class="validity"></span>
            </label>
            <label htmlFor="">
              To
              <input
                type="date"
                name="toDate"
                id="toDate"
                value={new Date(toDateValue).toLocaleDateString("en-ca")}
                min={new Date(fromDateValue).toLocaleDateString("en-ca")}
                onChange={handleDateChange}
              />
              <span class="validity"></span>
            </label>
          </div>
          <UploadModal
            img={img}
            preview={preview}
            setDescription={setDescription}
            description={description}
            onDescriptionChange={onDescriptionChange}
            percentage={percentage}
            setPercentage={setPercentage}
            isOpen={isOpen}
            close={close}
            open={open}
            isAlbum={true}
            albumId={albumId}
          />
          <ImagesContainer
            setSelectedImage={setSelectedImage}
            selectedImage={selectedImage}
            images={imgs}
            isLoading={isLoading}
            isAlbum={true}
            albumId={albumId}
          />
        </HomeWrapper>
      </MainPageLayout>
    </>
  );
}

export default AlbumDisc;
